
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/marketing/discountCodes",
      function () {
        return require("private-next-pages/admin/marketing/discountCodes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/marketing/discountCodes"])
      });
    }
  